<template>
  <b-modal dialog-class="full-width-modal" id="modal-brs" centered :title="title" hide-footer @hide="closeModal" @show="openModal">
    <form @submit.prevent>
      <div class="mt-2" v-show="!submitLoading">
        <div class="card">
          <div class="card-header" ref="modalBRS">Detail</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-md-3 mt-3">
                <label>
                  Title <span class="text-danger">*</span>
                  <small> ({{ (payload.name || '').length }}/200) </small>
                </label>
                <input type="text" class="form-control" v-model="payload.name" name="Title" maxlength="200" v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Title')">{{ errors.first('Title') }}</span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>IM Number <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="payload.im_number" name="Number" v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Number')">{{ errors.first('Number') }}</span>
              </div>

              <div class="col-md-6 col-md-3 mt-3">
                <label>Category <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="payload.im_category" name="Category" disabled v-validate="'required|max:200'" />
                <span class="text-sm text-danger" v-show="errors.has('Category')">{{ errors.first('Category') }}</span>
              </div>
              <div class="col-md-6 col-md-3 mt-3">
                <label>Year <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="year" name="im_year" disabled />
                <!--                <date-picker
                  v-model="payload.im_year"
                  type="year"
                  format="YYYY"
                  value-type="format"
                  name="Year"
                  v-validate="'required'"
                  class="w-100"
                  @input="getListDepartment"
                />
                <span class="text-sm text-danger" v-show="errors.has('Year')">{{ errors.first('Year') }}</span>-->

                <!--                <span class="text-sm text-danger" v-show="errors.has('IMYear')">
                  {{ errors.first('Year') }}
                </span>-->
                <span v-if="isYearUsed" class="text-sm text-danger mt-1"> Years must be the same with the one choosen in Internal Memo Project </span>
              </div>

              <div class="row">
                <div class="col-md-6 col-md-3 mt-3">
                  <label> Department Pengirim </label>
                  <multiselect
                    v-model="selectedDepartments"
                    :options="listDepartementsPengirim"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="false"
                    placeholder="Select/Type Here..."
                    :custom-label="customLabel"
                    track-by="id"
                    :disabled="!year"
                  >
                    <!-- Select All Checkbox -->
                    <template #beforeList>
                      <div class="multiselect__option">
                        <input type="checkbox" :checked="isAllSelected" @change="toggleSelectAll" />
                        <span style="margin-left: 6px">Select All</span>
                      </div>
                    </template>
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length" v-show="!isOpen"> {{ values.length }} Department(s) selected </span>
                    </template>
                  </multiselect>
                </div>
                <div class="col-md-6 col-md-3 mt-3">
                  <label> Department Penerima </label>
                  <multiselect
                    v-model="selectedDepartmentsPenerima"
                    :options="listDepartementsPenerima"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="false"
                    placeholder="Select/Type Here..."
                    :custom-label="customLabel"
                    track-by="id"
                    :disabled="!year"
                  >
                    <!-- Select All Checkbox -->
                    <template #beforeList>
                      <div class="multiselect__option">
                        <input type="checkbox" :checked="isAllSelectedPenerima" @change="toggleSelectAllPenerima" />
                        <span style="margin-left: 6px">Select All</span>
                      </div>
                    </template>
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                      <span class="multiselect__single" v-if="values.length" v-show="!isOpen"> {{ values.length }} Department(s) selected </span>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-md-6 col-md-6 mt-3">
                <div class="card">
                  <div class="card-header">Department Pengirim</div>
                  <div class="card-body">
                    <ul class="mr-0">
                      <li v-for="item in selectedDepartments" :key="item">
                        {{ item.department_name }}
                        <i
                          style="cursor: pointer; font-size: 20px"
                          class="fe fe-trash text-danger mr-1"
                          @click="removeSelectedPengirim(item?.id)"
                          v-if="checkDepartmentPengirimUsed(item?.id)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-md-6 mt-3">
                <div class="card">
                  <div class="card-header">Department Penerima</div>
                  <div class="card-body">
                    <ul class="mr-0">
                      <li v-for="item in selectedDepartmentsPenerima" :key="item">
                        {{ item.department_name }}
                        <i
                          style="cursor: pointer; font-size: 20px"
                          class="fe fe-trash text-danger mr-1"
                          @click="removeSelectedPenerima(item?.id)"
                          v-if="checkDepartmentPenerimaUsed(item?.id)"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="col-md-12 col-md-6 mt-3">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Used IM Value
                          <span
                            v-b-popover.hover.right="
                              'Value yang didapatkan dari total PO value yang menggunakan referensi terhadap relokasi yang ada pada Internal Memo BRS ini'
                            "
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="imUsedValue" disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Remaining IM Value
                          <span
                            v-b-popover.hover.right="'Value sisa dari total relocation yang belum digunakan pada PO'"
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="imRemainingValue" disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          Relocation Realization
                          <span
                            v-b-popover.hover.right="'Nilai Budget Relokasi yang sudah direalisasikan (sudah dibuatkan data relokasinya)'"
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," :value="imRelocationRealizationValue" disabled />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label>
                          IM Values / Total Relocation
                          <span
                            v-b-popover.hover.right="'Nilai Budget Relokasi total berdasarkan Internal Memo Project dan Internal Memo Attachment'"
                            variant="secondary"
                            style="cursor: pointer"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </label>
                        <vue-numeric class="form-control" currency="Rp. " separator="," v-model="payload.relocate_value" disabled />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">Internal Memo Files</div>
          <div class="card-body">
            <div class="col-md-12 col-md-6 mt-3 d-flex justify-content-end align-items-end">
              <button type="button" class="btn btn-primary ml-2" @click="addAttachment()">Add attachment</button>
            </div>
            <div class="row mb-3" v-for="(item, index) in attachmentElements" :key="`${item}`">
              <div class="col-md-12 col-md-6 mt-3 mb-3">
                <label>
                  <i
                    style="cursor: pointer; font-size: 20px"
                    class="fe fe-trash text-danger mr-1"
                    @click="removeAttachment(index)"
                    v-if="index !== 0"
                  />
                  {{ index == 0 ? 'Internal Memo (DOCX/PDF) (max size: 10MB)' : `Lampiran ${index} (DOCX/PDF) (max size: 10MB)` }}
                  <span v-if="index == 0" class="text-danger">*</span>
                </label>

                <input
                  type="file"
                  class="form-control"
                  :ref="`fileUpload_${index}`"
                  :name="`Attachment_${index}`"
                  accept=".pdf,.docx"
                  @change="fileUploader($event, index)"
                />
                <span v-if="index == 0">
                  <span class="text-sm text-danger" v-if="fileErrors?.[`attachments_${index}`]">
                    {{ fileErrors?.[`attachments_${index}`] }}
                  </span>
                </span>
                <!-- Display the list of selected files -->
                <div v-if="payload.files?.[index]">
                  <p>Selected File:</p>
                  <ul>
                    <li>
                      <a v-if="payload.files?.[index]?.url" :href="payload.files?.[index]?.url || ''" target="_blank">
                        {{ payload.files?.[index]?.name ? payload.files?.[index]?.name : payload.files?.[index]?.filename }}
                      </a>
                      <span v-else>
                        {{ payload.files?.[index]?.name ? payload.files?.[index]?.name : payload.files?.[index]?.filename }}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            Internal Memo Project
            <div class="d-flex justify-content-end align-items-end">
              <button type="button" class="btn btn-primary ml-2" @click="newIMProjects()">Add Project</button>
            </div>
          </div>
          <div class="card-body" v-for="(project, projectIndex) in this.payload.im_projects" :key="`project_${projectIndex}`">
            <div class="card">
              <div class="card-header">
                <h3 class="text-primary underline">Project {{ project.project_name || projectIndex + 1 }}</h3>
                <div class="d-flex justify-content-end align-items-end">
                  <button type="button" class="btn btn-primary ml-2" @click="newProjectRelocation(projectIndex)">Add Project Relocation</button>
                  <button
                    type="button"
                    class="btn btn-primary ml-2"
                    @click="removeIMProjects(projectIndex)"
                    :disabled="project.project_relocations?.some((item) => item.budget_relocate) === true"
                  >
                    Delete Project
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6 col-md-3 mt-3">
                    <label>Project Name</label>
                    <input
                      class="form-control"
                      type="text"
                      v-model="project.project_name"
                      :name="`${projectIndex}_project_name`"
                      :ref="`${projectIndex}_project_name`"
                      v-validate="'required'"
                    />
                    <span class="text-sm text-danger" v-show="errors.has(`${projectIndex}_project_name`)"> This field is required </span>
                  </div>
                  <div class="col-md-6 col-md-3 mt-3">
                    <label>Relocation Value</label>
                    <vue-numeric
                      :ref="`relocate_value_${projectIndex}`"
                      :name="`relocate_value_${projectIndex}`"
                      class="form-control"
                      currency="Rp. "
                      separator=","
                      v-model="project.relocate_value"
                      @input="validateProjectRelocateAll"
                    />
                    <span class="text-sm text-danger" v-show="imProjectErrors.includes(`im_project_${projectIndex}`)">
                      Total all relocations exceeds relocation value
                    </span>
                  </div>
                </div>
                <b-collapse v-model="project.showRelocateForm">
                  <div class="card mt-4">
                    <div class="card-body">
                      <h4 class="text-primary underline">{{ project.relocateFormTitle }}</h4>
                      <div class="row row-cols-1 row-cols-lg-2 g-3">
                        <div class="col">
                          <label>Department From</label>
                          <v-select
                            :options="selectedDepartments"
                            v-model="project_relocation.fund_center_id_from"
                            :reduce="(e) => e.id"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            label="department_name"
                            @input="selectDepartmentFrom"
                            :disabled="selectedDepartments.length === 0"
                          >
                            <template slot="option" slot-scope="option">
                              {{ `${option.department_name || ''}` }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              {{ `${option.department_name || ''}` }}
                            </template>
                          </v-select>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('fund_center_id_from')">
                            This field is required
                          </span>
                        </div>
                        <div class="col">
                          <label>Department To</label>
                          <v-select
                            :options="selectedDepartmentsPenerima"
                            v-model="project_relocation.fund_center_id_to"
                            :reduce="(e) => e.id"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            label="department_name"
                            @input="selectDepartmentTo"
                            :disabled="selectedDepartmentsPenerima.length === 0"
                          >
                            <template slot="option" slot-scope="option">
                              {{ `${option.department_name || ''}` }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              {{ `${option.department_name || ''}` }}
                            </template>
                          </v-select>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('fund_center_id_to')">
                            This field is required
                          </span>
                        </div>
                        <div class="col">
                          <label>Plan From</label>
                          <input class="form-control" type="text" :value="project_relocation.selectedPlanFrom" disabled />
                        </div>
                        <div class="col">
                          <label>Plan To</label>
                          <input class="form-control" type="text" :value="project_relocation.selectedPlanTo" disabled />
                        </div>
                        <div class="col">
                          <label>GL From</label>
                          <v-select
                            :options="listGLFrom"
                            v-model="project_relocation.gl_from"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            @input="selectGLFrom"
                            :disabled="!project_relocation.fund_center_id_from"
                          />
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('gl_from')"> This field is required </span>
                        </div>
                        <div class="col">
                          <label>GL To</label>
                          <v-select
                            :options="listGLTo"
                            v-model="project_relocation.gl_to"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            @input="selectGLTo"
                            :disabled="!project_relocation.fund_center_id_to"
                          />
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('gl_to')"> This field is required </span>
                        </div>
                        <div class="col">
                          <label>Budget Task From</label>
                          <v-select
                            :options="listBudgetTaskFrom"
                            v-model="project_relocation.budget_task_from"
                            :reduce="(e) => e.code"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            label="name"
                            :disabled="!project_relocation.gl_from"
                          >
                            <template slot="option" slot-scope="option">
                              {{ `${option.name || ''}` }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              {{ `${option.name || ''}` }}
                            </template>
                          </v-select>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('budget_task_from')">
                            This field is required
                          </span>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('duplicate_task')">
                            Duplicate budget task found
                          </span>
                        </div>
                        <div class="col">
                          <label>Budget Task To</label>
                          <v-select
                            :options="listBudgetTaskTo"
                            v-model="project_relocation.budget_task_to"
                            :reduce="(e) => e.code"
                            placeholder="Select/Type Here..."
                            class="w-md-auto"
                            label="name"
                            :disabled="!project_relocation.gl_to"
                          >
                            <template slot="option" slot-scope="option">
                              {{ `${option.name || ''}` }}
                            </template>
                            <template slot="selected-option" slot-scope="option">
                              {{ `${option.name || ''}` }}
                            </template>
                          </v-select>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('budget_task_to')">
                            This field is required
                          </span>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('duplicate_task')">
                            Duplicate budget task found
                          </span>
                        </div>
                        <div class="col">
                          <label>Delivery date</label>
                          <date-picker v-model="project_relocation.delivery_date" class="w-100 border-0" valueType="format" />
                          <!--                          <date-picker v-model="project_relocation.delivery_date" class="w-100 border-0" valueType="format" v-validate="'required'" />
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('delivery_date')">
                            Delivery Date in this line must be filled
                          </span>-->
                        </div>
                        <div class="col">
                          <label>Relocation Value</label>
                          <vue-numeric class="form-control" currency="Rp. " separator="," v-model="project_relocation.relocate_value" />
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('relocate_value')">
                            This field is required
                          </span>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('relocate_remaining')">
                            Cannnot more than project total relocation value: remaining Rp
                            {{ convertNumber(project.remaining_provision) }}
                          </span>
                        </div>
                      </div>
                      <div class="row row-cols-1 g-5 mt-0">
                        <!--
                        <div class="col">
                          <label>Relocation Value</label>
                          <vue-numeric class="form-control" currency="Rp. " separator="," v-model="project_relocation.relocate_value" />
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('relocate_value')">
                            This field is required
                          </span>
                          <span class="text-sm text-danger" v-show="projectRelocationFormErrors.includes('relocate_remaining')">
                            Cannnot more than project total relocation value: remaining Rp
                            {{ convertNumber(project.remaining_provision) }}
                          </span>
                        </div>
                        -->
                        <div class="col">
                          <div class="d-flex justify-content-end align-items-end">
                            <button class="btn btn-primary btn-sm" type="button" @click="saveProjectRelocation(projectIndex)">
                              <span class="fe fe-save mr-1"></span> Save
                            </button>
                            <button class="btn btn-secondary btn-sm ml-1" type="button" @click="resetFormProjectRelocation(projectIndex)">
                              <span class="fe fe-x mr-1"></span> Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
                <div class="container-fluid px-0 mt-4">
                  <vue-good-table
                    :columns="columnsRelocate"
                    :rows="payload.im_projects[projectIndex].project_relocations"
                    styleClass="vgt-table table-bordered w-100"
                  >
                    <div slot="emptystate" class="text-center font-size-14">No Relocation</div>
                    <template slot="table-row" slot-scope="props">
                      <div v-if="props.column.field == 'action'" class="d-flex align-items-center justify-content-center">
                        <template v-if="checkUsedPO(props.row.budget_relocate)">
                          <!--
                          <span
                            v-b-popover.hover.right="'Cannot edit or delete this project relocate because it has been used in budget relocation'"
                            variant="secondary"
                            style="cursor: pointer; font-size: 23px"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                          -->
                          <span
                            v-b-popover.hover.right="'Cannot edit or delete this project relocate because it has been used in budget actual'"
                            variant="secondary"
                            style="cursor: pointer; font-size: 23px"
                          >
                            <i class="fe fe-help-circle text-danger" style="cursor: help"></i>
                          </span>
                        </template>
                        <template v-else>
                          <b-button
                            class="no-wrap btn-pill mr-2"
                            variant="secondary"
                            size="sm"
                            @click="editProjectRelocation(projectIndex, props.index)"
                          >
                            <span class="fe fe-edit"></span>
                          </b-button>
                          <b-button class="no-wrap btn-pill" variant="primary" size="sm" @click="removeProjectsRelocation(projectIndex, props.index)">
                            <span class="fe fe-trash-2"></span>
                          </b-button>
                        </template>
                      </div>
                      <span v-else>{{ getRowValue(props, props.column.field) }}</span>
                      <div v-if="props.column.field == 'delivery_date'" class="d-flex align-items-center justify-content-center">
                        <template>
                          <span>
                            {{ props.row.delivery_date }}
                          </span>
                        </template>
                      </div>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end" v-if="!submitLoading">
        <button type="button" class="btn btn-outline-secondary" @click="closeConfirmModal">Cancel</button>
        <button class="btn btn-primary ml-2" :disabled="submitLoading || isYearUsed || isSubmit" @click="saveData">Submit</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import axiosIns from '@/api/axios';
import { ref } from 'vue';

export default {
  name: 'ModalFormBRS',
  props: { rowId: Number || null },
  data() {
    return {
      year: '',
      isYearUsed: false,
      isSubmit: false,
      showPengirim: false,
      showPenerima: false,
      oldYear: '',
      selectedDepartments: [],
      selectedDepartmentsPenerima: [],
      fileErrors: {},
      sumImValue: 0,
      sumImRemainingValue: 0,
      sumImUsedValue: 0,
      listDepartements: [],
      listDepartementsAll: [],
      listDepartementsPengirim: [],
      listDepartementsPenerima: [],
      attachmentElements: [],
      payload: {
        im_number: '',
        name: '',
        im_category: 'Budget Relocation Statement (BRS)',
        im_year: '',
        files: [],
        departments: [],
        departments_penerima: [],
        relocate_value: 0,
        im_projects: [],
      },
      submitLoading: false,
      im_project: {
        id: null,
        project_name: '',
        type: '',
        relocate_value: 0,
        used_value: 0,
        remaining_value: 0,
        project_relocations: [],
        showRelocateForm: false,
        relocateFormTitle: 'Add Relocation',
      },
      project_relocation: {
        id: null,
        fund_center_id_from: '',
        fund_from: '',
        gl_from: '',
        budget_task_from: '',
        fund_center_id_to: '',
        fund_to: '',
        gl_to: '',
        budget_task_to: '',
        relocate_value: 0,
        delivery_date: '',
        // selectedFundFrom: {},
        // selectedFundTo: {},
        selectedGLFrom: {},
        selectedGLTo: {},
        selectedBudgetTaskFrom: {},
        selectedBudgetTaskTo: {},
        selectedDepartmentFrom: {},
        selectedDepartmentTo: {},
        selectedPlanFrom: '',
        selectedPlanTo: '',
      },
      currentRelocateIndex: null,
      columnsRelocate: [
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
        {
          label: 'Department From',
          field: 'fund_center_id_from',
          minWidth: '150px',
        },
        {
          label: 'GL From',
          field: 'gl_from',
          minWidth: '150px',
        },
        {
          label: 'Budget Task From',
          field: 'budget_task_from',
          minWidth: '150px',
        },
        {
          label: 'Department To',
          field: 'fund_center_id_to',
          minWidth: '150px',
        },
        {
          label: 'GL To',
          field: 'gl_to',
          minWidth: '150px',
        },
        {
          label: 'Budget Task To',
          field: 'budget_task_to',
          minWidth: '150px',
        },
        {
          label: 'Relocation Value',
          field: 'relocate_value',
          minWidth: '150px',
        },
        {
          label: 'Delivery Date',
          field: 'delivery_date',
          minWidth: '150px',
        },
      ],
      // listFundFrom: [],
      // listFundTo: [],
      listGLFrom: [],
      listGLTo: [],
      listBudgetTaskFrom: [],
      listBudgetTaskTo: [],
      projectRelocationFormErrors: [],
      imProjectErrors: [],
      changedFiles: [],
      title: '',
    };
  },
  computed: {
    isAllSelected() {
      return this.selectedDepartments.length === this.listDepartements.length;
    },
    isAllSelectedPenerima() {
      return this.selectedDepartmentsPenerima.length === this.listDepartementsAll.length;
    },
    selectedDepartmentFrom() {
      return this.listDepartements?.find((item) => item.id === this.project_relocation.fund_center_id_from);
    },
    selectedDepartmentTo() {
      return this.listDepartementsAll?.find((item) => item.id === this.project_relocation.fund_center_id_to);
    },
    selectedPlanFrom() {
      if (!this.selectDepartmentFrom?.plan) return '';
      return `${this.selectDepartmentFrom?.plan?.title} version ${this.selectDepartmentFrom?.plan?.version}`;
    },
    selectedPlanTo() {
      if (!this.selectDepartmentTo?.plan) return '';
      return `${this.selectDepartmentTo?.plan?.title} version ${this.selectDepartmentTo?.plan?.version}`;
    },
    // selectedFundFrom() {
    //   return this.listFundFrom?.find((item) => item.fund === this.project_relocation.fund_from)
    // },
    // selectedFundTo() {
    //   return this.listFundTo?.find((item) => item.fund === this.project_relocation.fund_to)
    // },
    selectedGLFrom() {
      if (this.project_relocation.gl_from) {
        this.listBudgetTaskFrom = this.project_relocation.gl_from?.plan_budgets;
        this.project_relocation.selectedGLFrom = this.project_relocation.gl_from;
        this.project_relocation.fund_from = this.project_relocation.gl_from?.fund;
      }
      //return this.listGLFrom?.find((item) => item.gl_code === this.project_relocation.gl_from);
    },
    selectedGLTo() {
      if (this.project_relocation.gl_to) {
        this.listBudgetTaskTo = this.project_relocation.gl_to?.plan_budgets;
        this.project_relocation.selectedGLTo = this.project_relocation.gl_to;
        this.project_relocation.fund_to = this.project_relocation.gl_to?.fund;
      }
      //return this.listGLTo?.find((item) => item.gl_code === this.project_relocation.gl_to);
    },
    selectedBudgetTaskFrom() {
      return this.listBudgetTaskFrom?.find((item) => item.code === this.project_relocation.budget_task_from);
    },
    selectedBudgetTaskTo() {
      return this.listBudgetTaskTo?.find((item) => item.code === this.project_relocation.budget_task_to);
    },
    dataDetail() {
      if (this.rowId) return this.$store.getters['imNumber/detail'] || {};
    },
    imUsedValue() {
      return this.dataDetail?.budget_relocates?.reduce((total, item) => total + parseInt(item.totalPoValue), 0) || 0;
    },
    imRemainingValue() {
      return this.dataDetail?.relocate_value - this.imUsedValue || 0;
    },
    imRelocationRealizationValue() {
      return this.dataDetail?.budget_relocates?.reduce((total, item) => total + parseInt(item.relocate_value), 0) || 0;
    },
  },
  watch: {
    selectedDepartments: {
      handler() {
        this.payload.departments = this.selectedDepartments.map((item) => item.id);
        this.changeDepartment();
      },
      deep: true,
    },
    selectedDepartmentsPenerima: {
      handler() {
        this.payload.departments_penerima = this.selectedDepartmentsPenerima.map((item) => item.id);
        this.changeDepartment();
      },
      deep: true,
    },
    selectedDepartmentFrom: {
      handler() {
        const listGLFrom = [];

        this.selectedDepartmentFrom?.fund?.forEach((item) => {
          if (item.opex.length > 0) {
            item.opex.forEach((opex) => {
              listGLFrom.push({
                ...opex,
                type: 'OPEX',
                fund: item.fund,
                value: opex.gl_code,
                label: `OPEX | ${item.fund} |  ${opex.gl_code} | ${opex.item_name}`,
                customLabel: `OPEX | ${item.fund} |  ${opex.gl_code} | ${opex.item_name}`,
              });
            });
          }
          if (item.capex.length > 0) {
            item.capex.forEach((capex) => {
              listGLFrom.push({
                ...capex,
                type: 'CAPEX',
                fund: item.fund,
                value: capex.gl_code,
                label: `CAPEX | ${item.fund} |  ${capex.gl_code} | ${capex.item_name}`,
                customLabel: `CAPEX | ${item.fund} |  ${capex.gl_code} | ${capex.item_name}`,
              });
            });
          }
        });
        this.listGLFrom = listGLFrom;
        this.project_relocation.selectedDepartmentFrom = this.selectedDepartmentFrom;
        this.project_relocation.selectedPlanFrom = this.selectedDepartmentFrom?.plan
          ? `${this.selectedDepartmentFrom?.plan?.title} version ${this.selectedDepartmentFrom?.plan?.version}`
          : '';
      },
    },
    selectedDepartmentTo: {
      handler() {
        const listGLTo = [];

        this.selectedDepartmentTo?.fund?.forEach((item) => {
          if (item.opex.length > 0) {
            item.opex.forEach((opex) => {
              listGLTo.push({
                ...opex,
                type: 'OPEX',
                fund: item.fund,
                value: opex.gl_code,
                label: `OPEX | ${item.fund} |  ${opex.gl_code} | ${opex.item_name}`,
                customLabel: `OPEX | ${item.fund} |  ${opex.gl_code} | ${opex.item_name}`,
              });
            });
          }
          if (item.capex.length > 0) {
            item.capex.forEach((capex) => {
              listGLTo.push({
                ...capex,
                type: 'CAPEX',
                fund: item.fund,
                value: capex.gl_code,
                label: `CAPEX | ${item.fund} |  ${capex.gl_code} | ${capex.item_name}`,
                customLabel: `CAPEX | ${item.fund} |  ${capex.gl_code} | ${capex.item_name}`,
              });
            });
          }
        });
        this.listGLTo = listGLTo;
        this.project_relocation.selectedDepartmentTo = this.selectedDepartmentTo;
        this.project_relocation.selectedPlanTo = this.selectedDepartmentTo?.plan
          ? `${this.selectedDepartmentTo?.plan?.title} version ${this.selectedDepartmentTo?.plan?.version}`
          : '';
      },
    },
    // selectedFundFrom: {
    //   handler() {
    //     const capex = this.selectedFundFrom?.capex || []
    //     const opex = this.selectedFundFrom?.opex || []
    //     this.listGLFrom = [...capex, ...opex]
    //     this.project_relocation.selectedFundFrom = this.selectedFundFrom
    //     // console.log('selectedFundFrom', this.selectedFundFrom)
    //   },
    // },
    // selectedFundTo: {
    //   handler() {
    //     const capex = this.selectedFundTo?.capex || []
    //     const opex = this.selectedFundTo?.opex || []
    //     this.listGLTo = [...capex, ...opex]
    //     this.project_relocation.selectedFundTo = this.selectedFundTo
    //     // console.log('selectedFundTo', this.selectedFundTo)
    //   },
    // },
    selectedGLFrom: {
      handler() {
        /*this.listBudgetTaskFrom = this.selectedGLFrom?.plan_budgets;
        this.project_relocation.selectedGLFrom = this.selectedGLFrom;
        this.project_relocation.fund_from = this.selectedGLFrom?.fund;*/
        if (this.project_relocation.gl_from) {
          this.listBudgetTaskFrom = this.project_relocation.gl_from?.plan_budgets;
          this.project_relocation.selectedGLFrom = this.project_relocation.gl_from;
          this.project_relocation.fund_from = this.project_relocation.gl_from?.fund;
        }
      },
    },
    selectedGLTo: {
      handler() {
        /*this.listBudgetTaskTo = this.selectedGLTo?.plan_budgets;
        this.project_relocation.selectedGLTo = this.selectedGLTo;
        this.project_relocation.fund_to = this.selectedGLTo?.fund;
        // console.log('selectedGLTo', this.selectedGLTo)*/
        if (this.project_relocation.gl_to) {
          this.listBudgetTaskTo = this.project_relocation.gl_to?.plan_budgets;
          this.project_relocation.selectedGLTo = this.project_relocation.gl_to;
          this.project_relocation.fund_to = this.project_relocation.gl_to?.fund;
        }
      },
    },
    selectedBudgetTaskFrom: {
      handler() {
        this.project_relocation.selectedBudgetTaskFrom = this.selectedBudgetTaskFrom;
        // console.log('selectedBudgetTaskFrom', this.selectedBudgetTaskFrom)
      },
    },
    selectedBudgetTaskTo: {
      handler() {
        this.project_relocation.selectedBudgetTaskTo = this.selectedBudgetTaskTo;
        // console.log('selectedBudgetTaskTo', this.selectedBudgetTaskTo)
      },
    },
    'payload.im_projects': {
      handler() {
        this.calculateTotalRelocationIM();
        this.changeDepartment();
      },
      deep: true,
    },
    /*'payload.im_year': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.isYearUsed = false;
          this.oldYear = '';
          for (let p = 0; p < this.payload.im_projects.length; p++) {
            const project = this.payload.im_projects[p];

            const items = Array.isArray(project) ? project : project?.project_relocations || [];

            for (let i = 0; i < items.length; i++) {
              const item = items[i];

              const fromYear = item?.selectedBudgetTaskFrom?.year;
              const toYear = item?.selectedBudgetTaskTo?.year;
              if (fromYear || fromYear) {
                this.oldYear = fromYear || fromYear;
              }

              if ((String(fromYear) === String(this.oldYear) || String(toYear) === String(this.oldYear)) && String(newVal) !== String(this.oldYear)) {
                this.isYearUsed = true;
                break;
              }
            }

            if (this.isYearUsed) {
              break;
            }
          }
        }
        console.log(oldVal, '→', newVal);
      },
      immediate: false,
    },*/
  },
  methods: {
    checkUsedPO(row) {
      let isUsed = false;
      if (row?.budget_actuals.length > 0) {
        isUsed = true;
        return isUsed;
      }
      return isUsed;
    },
    removeSelectedPengirim(id) {
      this.selectedDepartments = this.selectedDepartments.filter((d) => d.id.toString() !== id.toString());
    },
    removeSelectedPenerima(id) {
      this.selectedDepartmentsPenerima = this.selectedDepartmentsPenerima.filter((d) => d.id.toString() !== id.toString());
    },
    checkDepartmentPengirimUsed(id) {
      let isUsed = true;
      const imProjects = this.payload.im_projects || [];

      if (imProjects?.length > 0) {
        for (let projectIndex = 0; projectIndex < imProjects.length; projectIndex++) {
          const project = imProjects[projectIndex];
          if (project.project_relocations?.length > 0) {
            for (let relocationIndex = 0; relocationIndex < project.project_relocations.length; relocationIndex++) {
              const relocation = project.project_relocations[relocationIndex];
              if (relocation?.fund_center_id_from && relocation?.fund_center_id_from.toString() === id.toString()) {
                isUsed = false;
                return isUsed;
              }
            }
          }
        }
      }
      return isUsed;
    },

    checkDepartmentPenerimaUsed(id) {
      let isUsed = true;
      const imProjects = this.payload.im_projects || [];

      if (imProjects?.length > 0) {
        for (let projectIndex = 0; projectIndex < imProjects.length; projectIndex++) {
          const project = imProjects[projectIndex];
          if (project.project_relocations?.length > 0) {
            for (let relocationIndex = 0; relocationIndex < project.project_relocations.length; relocationIndex++) {
              const relocation = project.project_relocations[relocationIndex];
              if (relocation?.fund_center_id_to && relocation?.fund_center_id_to.toString() === id.toString()) {
                isUsed = false;
                return isUsed;
              }
            }
          }
        }
      }
      return isUsed;
    },
    changeDepartment() {
      const imProjects = this.payload.im_projects || [];
      let fundCenterIds = [];
      let fundCenterIdsPenerima = [];

      if (imProjects?.length > 0) {
        for (let projectIndex = 0; projectIndex < imProjects.length; projectIndex++) {
          const project = imProjects[projectIndex];
          if (project.project_relocations?.length > 0) {
            for (let relocationIndex = 0; relocationIndex < project.project_relocations.length; relocationIndex++) {
              const relocation = project.project_relocations[relocationIndex];
              if (relocation?.fund_center_id_from) {
                fundCenterIds.push(relocation?.fund_center_id_from.toString());
              }
              if (relocation?.fund_center_id_to) {
                fundCenterIdsPenerima.push(relocation?.fund_center_id_to.toString());
              }
            }
          }
        }
      }
      this.listDepartementsPengirim = this.listDepartements.filter((item) => !fundCenterIds.includes(item.id.toString()));
      this.listDepartementsPenerima = this.listDepartementsAll.filter((item) => !fundCenterIdsPenerima.includes(item.id.toString()));
    },
    setShowPengirim(v) {
      this.showPengirim = v;
    },
    setShowPenerima(v) {
      this.showPenerima = v;
    },
    selectDepartmentFrom() {
      //reset child fields
      this.project_relocation.fund_from = '';
      this.project_relocation.gl_from = '';
      this.project_relocation.budget_task_from = '';
    },
    selectDepartmentTo() {
      //reset child fields
      this.project_relocation.fund_to = '';
      this.project_relocation.gl_to = '';
      this.project_relocation.budget_task_to = '';
    },
    // selectFundFrom() {
    //   //reset child fields
    //   this.project_relocation.gl_from = ''
    //   this.project_relocation.budget_task_from = ''
    // },
    // selectFundTo() {
    //   //reset child fields
    //   this.project_relocation.gl_to = ''
    //   this.project_relocation.budget_task_to = ''
    // },
    selectGLFrom() {
      //reset child fields
      this.project_relocation.budget_task_from = '';
      if (this.project_relocation.gl_from) {
        this.listBudgetTaskFrom = this.project_relocation.gl_from?.plan_budgets;
        this.project_relocation.selectedGLFrom = this.project_relocation.gl_from;
        this.project_relocation.fund_from = this.project_relocation.gl_from?.fund;
      }
      /*this.listBudgetTaskFrom = this.selectedGLFrom?.plan_budgets;
      this.project_relocation.selectedGLFrom = this.selectedGLFrom;
      this.project_relocation.fund_from = this.selectedGLFrom?.fund;*/
    },
    selectGLTo() {
      /* //reset child fields
      this.project_relocation.budget_task_to = '';*/
      this.project_relocation.budget_task_to = '';
      if (this.project_relocation.gl_to) {
        this.listBudgetTaskTo = this.project_relocation.gl_to?.plan_budgets;
        this.project_relocation.selectedGLTo = this.project_relocation.gl_to;
        this.project_relocation.fund_to = this.project_relocation.gl_to?.fund;
      }
    },
    // function to fetch project relocations to table
    async processProjectRelocate() {
      try {
        this.year = this.dataDetail?.im_year || '';
        this.payload = {
          ...this.payload,
          im_year: this.dataDetail?.im_year || this.year,
          name: this.dataDetail?.name || this.payload.name,
          im_number: this.dataDetail?.im_number || this.payload.im_number,
          im_category: this.dataDetail?.im_category || this.payload.im_category,
          files: this.dataDetail?.attachments || this.payload.files,
          relocate_value: this.dataDetail?.relocate_value || this.payload.relocate_value,
        };
        // set attachment elements
        for (let i = 1; i < this.dataDetail?.attachments.length; i++) {
          this.addAttachment();
        }
        // Ensure to load list department when dataDetail is available
        await this.getListDepartment();

        const departments = this.dataDetail?.departments ?? [];
        const { tempDepartment, tempDepartmentPenerima } = departments.reduce(
          (acc, item) => {
            item?.im_departments?.forEach((dept) => {
              if (dept.department_type === 'recipient') {
                acc.tempDepartmentPenerima.push({
                  ...item,
                  im_departments: dept,
                });
              } else {
                acc.tempDepartment.push({
                  ...item,
                  im_departments: dept,
                });
              }
            });

            return acc;
          },
          { tempDepartment: [], tempDepartmentPenerima: [] }
        );
        const fundCenterIds = tempDepartment?.map((item) => item.id) || [];
        const fundCenterIdsPenerima = tempDepartmentPenerima?.map((item) => item.id) || [];

        this.selectedDepartments = this.listDepartements.filter((item) => fundCenterIds.includes(item.id));
        this.selectedDepartmentsPenerima = this.listDepartementsAll.filter((item) => fundCenterIdsPenerima.includes(item.id));

        this.changeDepartment();

        const imProjects = this.dataDetail?.im_projects || [];

        const tempProjects = [];

        if (imProjects?.length > 0) {
          // Process each project
          for (let projectIndex = 0; projectIndex < imProjects.length; projectIndex++) {
            const project = imProjects[projectIndex];
            // Create project object with all required fields
            const newProject = {
              id: project.id,
              im_id: project.im_id,
              project_name: project.project_name || '',
              type: project.type || '',
              relocate_value: project.relocate_value || 0,
              used_value: project.used_value || 0,
              remaining_value: project.remaining_value || 0,
              project_relocations: [],
              showRelocateForm: false,
              relocateFormTitle: 'Add Relocation',
            };

            if (project.project_relocations?.length > 0) {
              // Process each relocation
              for (let relocationIndex = 0; relocationIndex < project.project_relocations.length; relocationIndex++) {
                const relocation = project.project_relocations[relocationIndex];

                // Initialize variables to store found objects
                let departmentFrom = null;
                let departmentTo = null;
                let fundFrom = null;
                let glFrom = null;
                let budgetTaskFrom = null;
                let fundTo = null;
                let glTo = null;
                let budgetTaskTo = null;

                for (const dept of this.listDepartements) {
                  let foundFrom = false;
                  let foundTo = false;

                  for (const fund of dept.fund || []) {
                    // Search through capex
                    for (const gl of fund.capex || []) {
                      for (const budget of gl.plan_budgets || []) {
                        if (budget.code === relocation.budget_task_from) {
                          let lbl = `${relocation?.budget_task_from_detail?.budget_type} | ${relocation?.budget_task_from_detail?.fund_name} |  ${relocation?.budget_task_from_detail?.gl_code} | ${gl.item_name}`;
                          let glFromNew = { ...gl, label: lbl, value: gl.gl_code, fund: relocation?.budget_task_from_detail?.fund_name };
                          departmentFrom = dept;
                          // fundFrom = fund
                          glFrom = glFromNew;
                          budgetTaskFrom = budget;
                          foundFrom = true;
                        }
                        if (budget.code === relocation.budget_task_to) {
                          let lbl = `${relocation?.budget_task_to_detail?.budget_type} | ${relocation?.budget_task_to_detail?.fund_name} |  ${relocation?.budget_task_to_detail?.gl_code} | ${gl.item_name}`;
                          let glFromNew = {
                            ...gl,
                            label: lbl,
                            value: relocation?.budget_task_to_detail?.gl_code,
                            fund: relocation?.budget_task_to_detail?.fund_name,
                          };
                          departmentTo = dept;
                          // fundTo = fund
                          glTo = glFromNew;
                          budgetTaskTo = budget;
                          foundTo = true;
                        }
                      }
                    }

                    // Search through opex
                    for (const gl of fund.opex || []) {
                      for (const budget of gl.plan_budgets || []) {
                        if (budget.code === relocation.budget_task_from) {
                          let lbl = `${relocation?.budget_task_from_detail?.budget_type} | ${relocation?.budget_task_from_detail?.fund_name} |  ${relocation?.budget_task_from_detail?.gl_code} | ${gl.item_name}`;
                          let glFromNew = { ...gl, label: lbl, value: gl.gl_code, fund: relocation?.budget_task_from_detail?.fund_name };
                          departmentFrom = dept;
                          // fundFrom = fund
                          glFrom = glFromNew;
                          budgetTaskFrom = budget;
                          foundFrom = true;
                        }
                        if (budget.code === relocation.budget_task_to) {
                          let lbl = `${relocation?.budget_task_to_detail?.budget_type} | ${relocation?.budget_task_to_detail?.fund_name} |  ${relocation?.budget_task_to_detail?.gl_code} | ${gl.item_name}`;
                          let glFromNew = {
                            ...gl,
                            label: lbl,
                            value: relocation?.budget_task_to_detail?.gl_code,
                            fund: relocation?.budget_task_to_detail?.fund_name,
                          };
                          departmentTo = dept;
                          // fundTo = fund
                          glTo = glFromNew;
                          budgetTaskTo = budget;
                          foundTo = true;
                        }
                      }
                    }

                    if (foundFrom && foundTo) break;
                  }

                  if (foundFrom && foundTo) break;
                }

                // Create the relocation object with all required fields
                let glFromNew = { ...glFrom, label: glFrom.item_name, value: glFrom.gl_code };
                const newRelocation = {
                  id: relocation.id,
                  im_projects_id: relocation.im_projects_id,
                  fund_center_id_from: departmentFrom?.id || '',
                  fund_from: fundFrom?.fund || relocation?.budget_task_from_detail?.fund_name || '',
                  gl_from: glFrom || [],
                  budget_task_from: budgetTaskFrom?.code || relocation.budget_task_from || '',
                  fund_center_id_to: departmentTo?.id || '',
                  fund_to: fundTo?.fund || relocation?.budget_task_to_detail?.fund_name || '',
                  gl_to: glTo || [],
                  budget_task_to: budgetTaskTo?.code || relocation.budget_task_to || '',
                  relocate_value: relocation.relocate_value || 0,
                  delivery_date: relocation.delivery_date || null,
                  // selectedFundFrom: fundFrom || {},
                  // selectedFundTo: fundTo || {},
                  selectedGLFrom: glFromNew || {},
                  selectedGLTo: glTo || {},
                  selectedBudgetTaskFrom: budgetTaskFrom || {},
                  selectedBudgetTaskTo: budgetTaskTo || {},
                  selectedDepartmentFrom: departmentFrom || {},
                  selectedDepartmentTo: departmentTo || {},
                  selectedPlanFrom: departmentFrom?.plan ? `${departmentFrom?.plan?.title} version ${departmentFrom?.plan?.version}` : '',
                  selectedPlanTo: departmentTo?.plan ? `${departmentTo?.plan?.title} version ${departmentTo?.plan?.version}` : '',
                  budget_relocate: this.dataDetail?.budget_relocates?.find((rel) => rel.im_projects_relocates_id === Number(relocation.id)) || null,
                };
                // Add the relocation to the project
                newProject.project_relocations.push(newRelocation);
              }
            } else {
              console.log(`Project ${projectIndex} has no relocations`);
            }
            // Add the project to payload
            tempProjects.push(newProject);
          }
        }

        this.payload.im_projects = [...tempProjects];
        // calculate remaining_value each project
        this.payload.im_projects.forEach((project, index) => {
          this.calculateRemainingValueProject(index);
        });
      } catch (error) {
        console.error('Error processing dataDetail:', error);
      }
    },
    async saveData() {
      this.fileErrors = {};
      const valid = await this.$validator.validateAll();
      // validate all
      this.validateProjectRelocateAll();

      // validate main internal memo file
      if (this.attachmentElements.length > 0) {
        this.attachmentElements.forEach((el, index) => {
          const fileObject = this.payload.files?.[index]?.name || this.payload.files?.[index]?.filename;
          if (!fileObject && index === 0) {
            this.fileErrors[`attachments_${index}`] = 'File is required';
            this.$nextTick(() => {
              const ref = this.$refs[`fileUpload_${index}`];
              const input = Array.isArray(ref) ? ref[0] : ref;

              if (input) {
                input.focus();
              }
            });
          }
        });
      }
      this.$forceUpdate();
      if (!valid || this.imProjectErrors.length > 0 || Object.keys(this.fileErrors).length > 0) {
        this.scrollToTopSmooth();
        console.error('Validation error:', this.errors);
        return;
      }

      try {
        this.isLoading = true;
        // Create payload
        const formData = new FormData();
        formData.append('name', this.payload.name);
        formData.append('im_number', this.payload.im_number);
        formData.append('im_category', this.payload.im_category);
        formData.append('im_year', this.year);
        formData.append('relocate_value', this.payload.relocate_value);

        const selectedDepartment = new Set(this.payload.departments); // Set to store unique values
        const selectedDepartmentPenerima = new Set(this.payload.departments_penerima); // Set to store unique values

        // only necessary data relocation
        formData.append(
          'im_projects',
          JSON.stringify(
            this.payload.im_projects.map((item) => {
              return {
                ...item,
                project_relocations: item.project_relocations.map((relocate) => {
                  //selectedDepartment.add(relocate.fund_center_id_from)
                  //selectedDepartmentPenerima.add(relocate.fund_center_id_to)
                  return {
                    fund_center_id_from: relocate.fund_center_id_from,
                    fund_center_id_to: relocate.fund_center_id_to,
                    fund_from: relocate.fund_from,
                    fund_to: relocate.fund_to,
                    gl_from: relocate.gl_from?.gl_code,
                    gl_to: relocate.gl_to?.gl_code,
                    budget_task_from: relocate.budget_task_from,
                    budget_task_to: relocate.budget_task_to,
                    relocate_value: relocate.relocate_value,
                    delivery_date: relocate.delivery_date,
                    id: relocate?.id,
                  };
                }),
              };
            })
          )
        );
        // add all selected department in relocation also

        formData.append('departments', JSON.stringify(Array.from(selectedDepartment)));
        formData.append('departments_penerima', JSON.stringify(Array.from(selectedDepartmentPenerima)));

        // Append each selected file
        this.payload.files.forEach((file, index) => {
          if (file instanceof File) {
            formData.append(`attachment_${index}`, file);
          } else {
            formData.append('files', JSON.stringify(file));
          }
        });

        // Append attachment elements for comparison in backend
        formData.append('attachment_elements', JSON.stringify(this.attachmentElements));

        await this.$store
          .dispatch(this.rowId ? 'imNumber/UPDATE_DATA' : 'imNumber/CREATE_DATA', this.rowId ? { id: this.rowId, data: formData } : formData)
          .then((resp) => {
            this.$swal('Saved', 'Your input has been saved', 'success').then(() => {
              this.submitLoading = false;
              this.resetFormAll();
              this.$emit('get-list-im');
              this.$emit('get-list-year');
              this.$emit('get-list-department');
              this.$emit('hide-modal');
            });
          })
          .catch((error) => {
            this.isLoading = false;
            const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
            });
            console.error('Error:', error);
          });
      } catch (error) {
        const errorMessage = error.response?.data?.error || 'An error occurred while saving data.';
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
        });
        console.error('Error:', error);
      }
    },
    toggleSelectAll(e) {
      if (e.target.checked) {
        this.selectedDepartments = [...this.listDepartements];
      } else {
        //this.selectedDepartments = [];
        const imProjects = this.payload.im_projects || [];
        let fundCenterIds = [];

        imProjects.forEach((project) => {
          project.project_relocations?.forEach((item) => {
            fundCenterIds.push(item.fund_center_id_from);
          });
        });
        this.selectedDepartments = this.selectedDepartments.filter((item) => fundCenterIds.includes(item.id));
      }
    },
    toggleSelectAllPenerima(e) {
      if (e.target.checked) {
        this.selectedDepartmentsPenerima = [...this.listDepartementsAll];
      } else {
        //this.selectedDepartmentsPenerima = [];
        const imProjects = this.payload.im_projects || [];
        let fundCenterIds = [];

        imProjects.forEach((project) => {
          project.project_relocations?.forEach((item) => {
            fundCenterIds.push(item.fund_center_id_to);
          });
        });
        this.selectedDepartmentsPenerima = this.selectedDepartmentsPenerima.filter((item) => fundCenterIds.includes(item.id));
      }
    },
    customLabel(option) {
      return `${option.department_code} - ${option.department_name}`;
    },
    async getListDepartment() {
      this.payload.departments = [];
      this.closeAllOpenedFormRelocate();
      try {
        const response = await axiosIns.get(`/fund-center/list-department-fund?year=${this.year}`);
        this.listDepartements = response.data.data.sort((a, b) => a.department_code.localeCompare(b.department_code)) || []; // ASC sort

        const responsePenerima = await axiosIns.get(`/fund-center/list-department-fund-penerima?year=${this.year}`);
        this.listDepartementsAll = responsePenerima.data.data.sort((a, b) => a.department_code.localeCompare(b.department_code)) || []; // ASC sort

        this.changeDepartment();
      } catch (error) {
        console.error('Failed to fetch year options:', error);
      }
    },
    newIMProjects() {
      this.payload.im_projects.push({
        project_name: '',
        type: '',
        relocate_value: 0,
        used_value: 0,
        remaining_value: 0,
        project_relocations: [],
        showRelocateForm: false,
        relocateFormTitle: 'Add Relocation',
      });
    },
    removeIMProjects(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.payload.im_projects.splice(i, 1);
            this.$swal('Deleted!', 'Project has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    newProjectRelocation(projectIndex) {
      this.closeAllOpenedFormRelocate();
      this.payload.im_projects[projectIndex].showRelocateForm = true;
      this.payload.im_projects[projectIndex].relocateFormTitle = 'Add Relocation';
      this.currentRelocateIndex = this.payload.im_projects[projectIndex].project_relocations.length;
    },
    editProjectRelocation(projectIndex, relocationIndex) {
      this.closeAllOpenedFormRelocate();
      this.payload.im_projects[projectIndex].showRelocateForm = true;
      this.payload.im_projects[projectIndex].relocateFormTitle = 'Edit Relocation';
      const rowRelocation = this.payload.im_projects[projectIndex].project_relocations[relocationIndex];
      this.currentRelocateIndex = relocationIndex;
      if (!this.selectedDepartments.find((item) => item.id === rowRelocation.fund_center_id_from)) {
        this.selectedDepartments.push(rowRelocation.selectedDepartmentFrom);
      }
      if (!this.selectedDepartmentsPenerima.find((item) => item.id === rowRelocation.fund_center_id_to)) {
        this.selectedDepartmentsPenerima.push(rowRelocation.selectedDepartmentTo);
      }
      // clone object to preven update the table reactively
      this.project_relocation = { ...rowRelocation };
    },
    removeProjectsRelocation(projectIndex, relocationIndex) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.payload.im_projects[projectIndex].project_relocations.splice(relocationIndex, 1);
            this.$swal('Deleted!', 'Project relocation has been deleted', 'success');
          } catch (e) {
            console.log(e);
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    saveProjectRelocation(projectIndex, validate = true) {
      if (validate) {
        this.calculateRemainingValueProject(projectIndex);
        this.validateProjectRelocateForm(projectIndex);
        //console.log('projectRelocationFormErrors', this.projectRelocationFormErrors);
        if (this.projectRelocationFormErrors.length > 0) {
          return;
        }
      }
      //need to copy the array for trigger reactive since vue can't detect changes using index
      const relocations = [...this.payload.im_projects[projectIndex].project_relocations];
      const index = this.currentRelocateIndex !== null ? this.currentRelocateIndex : relocations.length;

      if (this.currentRelocateIndex !== null) {
        // Replace at index
        relocations[index] = { ...this.project_relocation };
      } else {
        // Add new
        relocations.push({ ...this.project_relocation });
      }

      // Assign new array to trigger reactivity
      this.payload.im_projects[projectIndex].project_relocations = relocations;

      this.closeAllOpenedFormRelocate();
    },
    addAttachment() {
      this.attachmentElements.push(`attachment_${this.attachmentElements.length}`);
    },
    removeAttachment(i) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            this.attachmentElements.splice(i, 1);
            this.payload.files.splice(i, 1); // remove index > 0
            this.$swal('Deleted!', 'Attachment has been deleted', 'success');
          } catch (e) {
            this.$swal('Error', 'Error while delete data', 'error');
          }
        }
      });
    },
    async openModal() {
      this.attachmentElements.push('attachment_0');
      if (this.rowId) {
        this.getDetail();
        this.title = 'Edit Internal Memo BRS';
      } else {
        const currentYear = new Date().getFullYear();
        this.year = currentYear.toString();
        this.resetFormAll();
        this.addAttachment();
        this.title = 'Add Internal Memo BRS';
        await this.getListDepartment();
      }
    },
    closeModal(evt) {
      if (evt.trigger === 'backdrop') {
        evt.preventDefault();
      }
      if (evt.trigger === 'headerclose') {
        evt.preventDefault();
        this.closeConfirmModal();
      }
    },
    closeConfirmModal(evt) {
      this.$swal({
        title: 'Are you sure ?',
        text: 'This form BRS will be canceled',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: `Yes, i'm sure!`,
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          this.resetFormAll();
          this.$emit('hide-modal');
        }
      });
    },
    resetFormAll() {
      this.payload = {
        im_number: '',
        name: '',
        im_category: 'Budget Relocation Statement (BRS)',
        //im_year: '',
        files: [],
        departments: [],
        relocate_value: '',
        im_projects: [],
      };
      this.attachmentElements = [];
      this.selectedDepartments = [];
      this.selectedDepartmentsPenerima = [];
      this.im_project = {
        project_name: '',
        type: '',
        relocate_value: 0,
        used_value: 0,
        remaining_value: 0,
        project_relocations: [],
        showRelocateForm: false,
        relocateFormTitle: 'Add Relocation',
      };
      this.resetFormProjectRelocation();
    },
    resetFormProjectRelocation(index = null) {
      this.isSubmit = false;
      if (index !== null) {
        this.payload.im_projects[index].showRelocateForm = false;
      }
      this.project_relocation = {
        fund_center_id_from: '',
        fund_from: '',
        gl_from: '',
        budget_task_from: '',
        fund_center_id_to: '',
        fund_to: '',
        gl_to: '',
        budget_task_to: '',
        relocate_value: 0,
        // selectedFundFrom: {},
        // selectedFundTo: {},
        selectedGLFrom: {},
        selectedGLTo: {},
        selectedBudgetTaskFrom: {},
        selectedBudgetTaskTo: {},
        selectedDepartmentFrom: {},
        selectedDepartmentTo: {},
        delivery_date: '',
      };
      this.currentRelocateIndex = null;
      // this.listFundFrom = []
      // this.listFundTo = []
      this.listGLFrom = [];
      this.listGLTo = [];
      this.listBudgetTaskFrom = [];
      this.listBudgetTaskTo = [];
      this.projectRelocationFormErrors = [];
    },
    async fileUploader(event, index = 0) {
      const file = event.target.files[0];
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      const allowedTypes = ['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (!file) {
        this.fileErrors[`attachments_${index}`] = 'File is required';
        return;
      }

      // Validate file size
      if (file.size > maxSize) {
        this.fileErrors[`attachments_${index}`] = 'File size must be less than 5MB.';

        this.$swal.fire({
          title: 'Error',
          text: 'File size must be less than 5MB.',
          icon: 'error',
          confirmButtonText: 'OK',
        });

        this.$refs[`fileUpload_${index}`].value = ''; // Reset file input
        this.payload.files[index] = null;
        return;
      }

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        this.fileErrors[`attachments_${index}`] = 'Only PDF or DOCX files are allowed.';
        this.$refs.fileUpload.value = ''; // Reset file input

        this.$swal.fire({
          title: 'Error',
          text: 'Only PDF or DOCX files are allowed.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
        this.$refs[`fileUpload_${index}`].value = ''; // Reset file input
        this.payload.files[index] = null;
        return;
      }
      this.payload.files[index] = file;
      // Trigger reactivity
      this.$forceUpdate();
    },
    scrollToTopSmooth() {
      const modalContent = this.$refs.modalBRS;
      if (!modalContent) return;

      modalContent.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    },
    closeAllOpenedFormRelocate() {
      this.payload.im_projects.forEach((item, index) => {
        this.resetFormProjectRelocation(index);
      });
      this.currentRelocateIndex = null;
      this.isSubmit = false;
    },
    convertNumber(amount) {
      return amount ? amount.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') : '0';
    },
    getRowValue(props, field) {
      let value = '';
      switch (field) {
        case 'fund_center_id_from':
          value = props.row.selectedDepartmentFrom?.department_name;
          break;
        // case 'fund_from':
        //   value = props.row.selectedFundFrom?.fund
        //   break
        case 'gl_from':
          value = `${props.row.selectedGLFrom?.gl_code} - ${props.row.selectedGLFrom?.item_name}`;
          break;
        case 'budget_task_from':
          value = props.row.selectedBudgetTaskFrom?.name;
          break;
        case 'fund_center_id_to':
          value = props.row.selectedDepartmentTo?.department_name;
          break;
        // case 'fund_to':
        //   value = props.row.selectedFundTo?.fund
        //   break
        case 'gl_to':
          value = `${props.row.selectedGLTo?.gl_code} - ${props.row.selectedGLTo?.item_name}`;
          break;
        case 'budget_task_to':
          value = props.row.selectedBudgetTaskTo?.name;
          break;
        case 'relocate_value':
          value = `Rp. ${this.convertNumber(props.row.relocate_value)}`;
          break;
      }

      return value;
    },
    getDetail() {
      if (this.rowId) {
        this.$store.dispatch('imNumber/GET_DETAIL', this.rowId).then(() => {
          this.processProjectRelocate();
        });
      }
    },
    calculateRemainingValueProject(projectIndex) {
      this.payload.im_projects = this.payload.im_projects.map((project) => {
        const totalRelocation = project.project_relocations.reduce((acc, curr) => acc + (parseInt(curr.relocate_value) || parseInt(0)), parseInt(0));
        project.remaining_provision = parseInt(project.relocate_value) - totalRelocation;
        return project;
      });
    },
    calculateTotalRelocationIM() {
      if (this.payload.im_projects.length > 0) {
        this.payload.relocate_value = this.payload.im_projects.reduce(
          (acc, curr) => acc + (parseInt(curr.relocate_value) || parseInt(0)),
          parseInt(0)
        );
      }
    },
    validateProjectRelocateForm(projectIndex) {
      this.isSubmit = false;
      this.projectRelocationFormErrors = [];
      Object.keys(this.project_relocation).forEach((key) => {
        if (!this.project_relocation[key] && this.project_relocation[key] !== null) {
          this.projectRelocationFormErrors.push(key);
        }
      });

      let totalRelocationProject = this.payload.im_projects[projectIndex].project_relocations.reduce(
        (acc, curr) => acc + (parseInt(curr.relocate_value) || parseInt(0)),
        parseInt(0)
      );
      const relocateValue = parseInt(this.payload.im_projects[projectIndex].relocate_value);
      // exclude current relocation from calculation if editing
      totalRelocationProject -=
        parseInt(this.payload.im_projects[projectIndex].project_relocations?.[this.currentRelocateIndex]?.relocate_value) || 0;

      if (relocateValue - totalRelocationProject < this.project_relocation.relocate_value) {
        this.projectRelocationFormErrors.push('relocate_remaining');
      }
      // check duplication
      if (this.selectedBudgetTaskFrom?.code === this.selectedBudgetTaskTo?.code) {
        this.projectRelocationFormErrors.push('duplicate_task');
      }
      if (this.projectRelocationFormErrors.length > 0) {
        this.isSubmit = true;
      }
    },
    validateProjectRelocateAll() {
      this.imProjectErrors = [];
      this.payload.im_projects.forEach((item, projectIndex) => {
        if (!item.project_name) {
          this.$nextTick(() => {
            const els = document.getElementsByName(`${projectIndex}_project_name`);
            const el = els?.[0];

            if (el) {
              const input = el.tagName === 'INPUT' ? el : el.querySelector('input');

              input?.focus();
            }
          });
        }

        const totalRelocationProject = item.project_relocations.reduce(
          (acc, curr) => acc + (parseInt(curr.relocate_value) || parseInt(0)),
          parseInt(0)
        );
        if (item.relocate_value < totalRelocationProject) {
          this.imProjectErrors.push(`im_project_${projectIndex}`);
          this.$nextTick(() => {
            const els = document.getElementsByName(`relocate_value_${projectIndex}`);
            const el = els?.[0];

            if (el) {
              const input = el.tagName === 'INPUT' ? el : el.querySelector('input');

              input?.focus();
            }
          });
        }
      });
    },
  },
  mounted() {
    if (this.rowId) {
      this.title = 'Edit Internal Memo BRS';
    } else {
      this.title = 'Add Internal Memo BRS';
    }
  },
};
</script>
<style scoped>
.full-width-modal {
  min-width: 95vw !important;
  margin: 2.5% auto;
}
</style>
